var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:[
    'chart-li-wrap',
    _vm.direction ? _vm.direction : ''
  ]},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:[
      'chart-li__item',
      index === 0 ? 'first' : '',
      item.name ? 'code-names' : ''
    ]},[(item.name)?_c('b',{class:[ item.name == 'my' ? 'mine' : 'avarge',]}):_c('i',{staticClass:"chart-li__circle",style:({ background: item.color })}),_c('span',{staticClass:"chart-li__text"},[_vm._v(_vm._s(item.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }